import AccountResolver from "resolvers/RTMResolvers/AccountResolver";

export default (() => {
  /**
   * @type {AccountResolver}
   */
  let accountResolver;
  let isRegistered = false;
  let _currentUser;

  const getCurrentUser = async () => {
    if(_currentUser){
      return _currentUser;
    }
    _currentUser = await accountResolver.getCurrentUser();
    return _currentUser;
  };

  return {
    isRegistered: () => isRegistered,
  
    register: (connectionProvider) => {
      isRegistered = true;
      accountResolver = new AccountResolver(connectionProvider);
    },
      
    getCurrentUser,
  };
})();
  
